var map = {
	"./diamond-cut-1.jpg": 113,
	"./diamond-cut-1@2x.jpg": 56,
	"./diamond-cut-1@3x.jpg": 57,
	"./diamond-cut-2.jpg": 114,
	"./diamond-cut-2@2x.jpg": 58,
	"./diamond-cut-2@3x.jpg": 59,
	"./diamond-cut-3.jpg": 115,
	"./diamond-cut-3@2x.jpg": 60,
	"./diamond-cut-3@3x.jpg": 61,
	"./diamond-cut-4.jpg": 116,
	"./diamond-cut-4@2x.jpg": 62,
	"./diamond-cut-4@3x.jpg": 63,
	"./diamond-cut-5.jpg": 117,
	"./diamond-cut-5@2x.jpg": 64,
	"./diamond-cut-5@3x.jpg": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;